var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          {
            staticClass:
              "l-m-b-20 align-items-center d-flex justify-content-between"
          },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center title-search" },
              [
                _c("h1", { staticClass: "pr-3" }, [_vm._v("Filters")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group search" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn input-group-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.clearSearch }
                    },
                    [
                      _c("i", {
                        class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.q,
                        expression: "q"
                      }
                    ],
                    staticClass: "form-control search-input",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.q },
                    on: {
                      keyup: function($event) {
                        _vm.searchText($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.q = $event.target.value
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 text-right pr-0 mobile-hidden" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-schedule",
                  on: {
                    click: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.toggleShared($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.showShared ? "Hide shared" : "Show shared") +
                      "\n        "
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.filterTemplates
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : !_vm.filterTemplates.length
          ? [_c("span", [_vm._v("There are no results.")])]
          : [
              _vm._m(0),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "blocks" },
                  _vm._l(_vm.filterTemplates, function(filterTemplate, ind) {
                    return _c(
                      "div",
                      {
                        key: ind,
                        staticClass:
                          "w-100 d-flex align-items-center justify-content-between bg-white rounded p-2 mt-3",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            _vm.user.id ===
                              filterTemplate.cluster_user.user_id &&
                              _vm.openEditFilterTemplate(filterTemplate)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-3 col-2 d-flex justify-content-start",
                            staticStyle: { "min-width": "100px" },
                            on: {
                              click: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                _vm.user.id ===
                                  filterTemplate.cluster_user.user_id &&
                                  _vm.openEditFilterTemplate(filterTemplate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filterTemplate.name) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex col-2 align-items-center justify-content-start flex-wrap",
                            on: {
                              click: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                _vm.user.id ===
                                  filterTemplate.cluster_user.user_id &&
                                  _vm.openEditFilterTemplate(filterTemplate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filterTemplate.filter_route.name) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex col-3 align-items-center justify-content-start flex-wrap",
                            on: {
                              click: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                _vm.user.id ===
                                  filterTemplate.cluster_user.user_id &&
                                  _vm.openEditFilterTemplate(filterTemplate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filterTemplate.cluster_user.full_name) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex col-1 align-items-center justify-content-start flex-wrap",
                            on: {
                              click: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                _vm.user.id ===
                                  filterTemplate.cluster_user.user_id &&
                                  _vm.openEditFilterTemplate(filterTemplate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filterTemplate.default ? "Yes" : "No") +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex col-1 align-items-center justify-content-start flex-wrap",
                            on: {
                              click: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                _vm.user.id ===
                                  filterTemplate.cluster_user.user_id &&
                                  _vm.openEditFilterTemplate(filterTemplate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filterTemplate.shared ? "Yes" : "No") +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex col-2 align-items-center justify-content-start flex-wrap",
                            on: {
                              click: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                _vm.user.id ===
                                  filterTemplate.cluster_user.user_id &&
                                  _vm.openEditFilterTemplate(filterTemplate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filterTemplate.updated_at) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex col-1 align-items-center justify-content-end flex-wrap"
                          },
                          [
                            _c("div", { staticClass: "dropdown" }, [
                              _c("button", {
                                staticClass: "btn btn-secondary add-filter",
                                attrs: {
                                  type: "button",
                                  id: "dropdownMenuButton" + ind,
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              }),
                              _vm._v(" "),
                              _vm.user.id ===
                              filterTemplate.cluster_user.user_id
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby":
                                          "dropdownMenuButton" + ind
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "dropdown-item nav-link btn",
                                          on: {
                                            click: function($event) {
                                              _vm.openEditFilterTemplate(
                                                filterTemplate
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Edit Filter\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "dropdown-item nav-link btn",
                                          on: {
                                            click: function($event) {
                                              _vm.filterTemplateDelete = filterTemplate
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Remove Filter\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby":
                                          "dropdownMenuButton" + ind
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "dropdown-item nav-link btn",
                                          on: {
                                            click: function($event) {
                                              _vm.sharedFilterTemplate = filterTemplate
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Manage Sharing\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ])
                          ]
                        )
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row blocks" },
                  [
                    _vm.meta.total
                      ? _c(
                          "div",
                          { staticClass: "col-sm-6 mb-1 pl-0 text-black-50" },
                          [
                            _vm._v(
                              "\n          Showing " +
                                _vm._s(_vm.meta.from) +
                                " - " +
                                _vm._s(_vm.meta.to) +
                                " of " +
                                _vm._s(_vm.meta.total) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("pagination", {
                      staticClass: "col-sm-6 mb-1 pr-0",
                      attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                    })
                  ],
                  1
                )
              ])
            ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "filters-side-modal flex flex-column justify-content-start"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.companies && _vm.companies.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Companies")]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              options: _vm.companies,
                                              "input-id": "status-select",
                                              placeholder: "Select Company"
                                            },
                                            on: { input: _vm.triggerSearch },
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm.filters.company
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showEditFilterTemplate,
                expression: "showEditFilterTemplate"
              }
            ],
            staticClass: "l-modal-mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeAllModals($event)
              }
            }
          },
          [
            _c("div", { staticClass: "sidebar-right" }, [
              _c("div", { staticClass: "filters-form-wrapper" }, [
                _c("div", { staticClass: "w-100" }, [
                  _c("h1", { staticClass: "modal-h1 mb-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: { click: _vm.closeAllModals }
                    }),
                    _vm._v("\n              Update Filter\n            ")
                  ]),
                  _vm._v(" "),
                  _vm.editFilterTemplate
                    ? _c(
                        "form",
                        {
                          staticClass: "form-right",
                          attrs: { autocomplete: "no" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.saveEditFilterTemplate($event)
                            },
                            keydown: function($event) {
                              _vm.clearError($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col p-1" },
                              [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c("label", [_vm._v("Name: ")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editFilterTemplate.name,
                                        expression: "editFilterTemplate.name"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Enter Name",
                                      maxlength: "100"
                                    },
                                    domProps: {
                                      value: _vm.editFilterTemplate.name
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editFilterTemplate,
                                          "name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: { errors: _vm.errors, field: "name" }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col p-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "select-wrap" },
                                  [
                                    _c("label", [_vm._v("Default: ")]),
                                    _vm._v(" "),
                                    _c("simple-select", {
                                      attrs: {
                                        options: _vm.booleanOptions,
                                        "input-id": "default-select",
                                        placeholder: "Default"
                                      },
                                      model: {
                                        value: _vm.editFilterTemplate.default,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editFilterTemplate,
                                            "default",
                                            $$v
                                          )
                                        },
                                        expression: "editFilterTemplate.default"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: {
                                    errors: _vm.errors,
                                    field: "default"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col p-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "select-wrap" },
                                  [
                                    _c("label", [_vm._v("Shared: ")]),
                                    _vm._v(" "),
                                    _c("simple-select", {
                                      attrs: {
                                        options: _vm.booleanOptions,
                                        "input-id": "shared-select",
                                        placeholder: "Shared"
                                      },
                                      model: {
                                        value: _vm.editFilterTemplate.shared,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editFilterTemplate,
                                            "shared",
                                            $$v
                                          )
                                        },
                                        expression: "editFilterTemplate.shared"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: { errors: _vm.errors, field: "shared" }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "buttons-down text-right" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-delete float-left",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.filterTemplateDelete =
                                        _vm.originalEditFilterTemplate
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Delete\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.closeAllModals }
                                },
                                [
                                  _vm._v(
                                    "\n                  Cancel\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary ld-ext-right",
                                  class: _vm.loadingButton ? "running" : "",
                                  attrs: { disabled: _vm.buttonDisabled }
                                },
                                [
                                  _vm._v(
                                    "\n                  Update\n                  "
                                  ),
                                  _c("span", {
                                    staticClass: "ld ld-ball ld-flip"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.filterTemplateDelete !== null
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.filterTemplateDelete = null
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-black-50 d-flex align-items-center justify-content-start"
                  },
                  [
                    _vm._v(
                      "Delete Filter: " + _vm._s(_vm.filterTemplateDelete.name)
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v(
                    "Are you sure you want to delete filter with name " +
                      _vm._s(_vm.filterTemplateDelete.name) +
                      "?"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-center",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.removeFilterTemplate }
                    },
                    [_vm._v("Yes")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function($event) {
                          _vm.filterTemplateDelete = null
                        }
                      }
                    },
                    [_vm._v("No")]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sharedFilterTemplate !== null
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.sharedFilterTemplate = null
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-black-50 d-flex align-items-center justify-content-start"
                  },
                  [
                    _vm._v(
                      "Share Filter: " + _vm._s(_vm.sharedFilterTemplate.name)
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v("Add or remove filter from your list.")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-center" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sharedFilterTemplate.default,
                        expression: "sharedFilterTemplate.default"
                      }
                    ],
                    attrs: { id: "default-checkbox", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.sharedFilterTemplate.default)
                        ? _vm._i(_vm.sharedFilterTemplate.default, null) > -1
                        : _vm.sharedFilterTemplate.default
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.sharedFilterTemplate.default,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.sharedFilterTemplate,
                                "default",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.sharedFilterTemplate,
                                "default",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.sharedFilterTemplate, "default", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "default-checkbox" } }, [
                    _vm._v("Set as default")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-center",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.shareFilterTemplate }
                    },
                    [_vm._v("Add filter")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: { click: _vm.removeSharedFilterTemplate }
                    },
                    [_vm._v("Remove filter")]
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "blocks" }, [
      _c(
        "div",
        {
          staticClass:
            "filters-header w-100 d-flex align-items-center justify-content-between mb-2 p-2"
        },
        [
          _c(
            "div",
            { staticClass: "mr-3 col-2 d-flex justify-content-start" },
            [_vm._v("\n          Name\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "filters-header-value col-2 align-items-center justify-content-start flex-wrap"
            },
            [_vm._v("\n          Page\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "filters-header-value col-3 align-items-center justify-content-start flex-wrap"
            },
            [_vm._v("\n          Owner\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "filters-header-value col-1 align-items-center justify-content-start flex-wrap"
            },
            [_vm._v("\n          Default\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "filters-header-value col-1 align-items-center justify-content-start flex-wrap"
            },
            [_vm._v("\n          Shared\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "filters-header-value col-2 align-items-center justify-content-start flex-wrap"
            },
            [_vm._v("\n          Updated at\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "filters-header-value col-1 align-items-center justify-content-end flex-wrap"
            },
            [_vm._v("\n           \n        ")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7b57cd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7b57cd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/FilterTemplates/FilterTemplates.vue
// module id = null
// module chunks = 